import React, { useState, useEffect, useRef } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../components/mensajes';
import CartasFinanza from './cartas';
import { formatMoneda, validaSoloNumero, validaMonto, formatoMonto } from '../../util/varios';
import moment from 'moment';
import useTable from "../../components/useTable";
import CatalogoCuentaBancaria from '../../catalogos/catalogoCuentasBancarias';
import { IncluirMovimiento } from './incluirMovimientosTransito';

const TablaMovimientosTransito = () => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  let anio = JSON.parse(sessionStorage.getItem('anioactu'));

  const headCells = [
    { id: 'idmovimientosentransito', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' },
    { id: 'tipomov', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'TIPO', textAlign: 'center' },
    { id: 'referencia', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'REFERENCIA', textAlign: 'center' },
    { id: 'fecha', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    { id: 'monto', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]

  const txtIdCuentaBancaria = useRef();
  const txtCuenta = useRef();


  const txtBuscador = useRef();

  const [operacion, setOperacion] = useState(0);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);

  const [mostrar, setMostrar] = useState(false);
  const [body, setBody] = useState(null);
  const [habilitado, setHabilitado] = useState(false);
  const [idMovimiento, setIdMovimiento] = useState('0');
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const [records, setRecords] = useState([]);
  const [regDet, setRegDet] = useState();

  const handleSearch = e => {
    let target = e.target;
    let st = '';
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {
            (st = x.status === '51' ? 'activo' : 'inactivo')
            if (x.idmovimientosentransito.includes(target.value)
              || x.tipomov.toLowerCase().includes(target.value.toLowerCase())
              || x.referencia.toLowerCase().includes(target.value.toLowerCase())
              || moment(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase())
              || formatMoneda(x.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2).toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;//alert(e.which);
  };


  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const seleccionarCuentaBancaria = (id) => {

    let campos = "*";
    let nomtab = 'cuentabancaria';
    let nomid = 'idcuentabancaria';

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid} `
    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data !== '') {
          txtCuenta.current.value = response.data.nombre.trim() + ' --- ' + response.data.cuentabancaria.trim();
          seleccionarMovimientos(response.data.idcuentabancaria);
          setTimeout(() => txtBuscador.current.focus(), 200);
        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'ID no existe.', icono: 'informacion' });
          txtIdCuentaBancaria.current.value = '';
          txtIdCuentaBancaria.current.focus();
        }
      }
      setActivate(false)
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })

  };

  const seleccionarMovimientos = (id) => {

    let campos = "*";
    let nomtab = 'movimientosentransito';
    let nomid = 'idcuentabancaria';
    let condic = 'true';

    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`
    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {
        setRecords([]);
        if (response.data.length > 0) {
          var mov = [];
          for (let i = 0; i < response.data.length; i++) {
            mov.push({
              idmovimientosentransito: response.data[i].idmovimientosentransito,
              idcuentabancaria: response.data[i].idcuentabancaria,
              fecha: response.data[i].fecha,
              fechasis: response.data[i].fechasis,
              referencia: response.data[i].referencia,
              motivo: response.data[i].motivo,
              monto: response.data[i].monto,
              tipo: response.data[i].tipo,
              reversado: response.data[i].reversado,
              conciliado: response.data[i].conciliado,
              fechareversado: response.data[i].fechareversado,
              fechaconciliacion: response.data[i].fechaconciliacion,
              tipomov: response.data[i].tipo === 0 ? 'DEPOSITO' : response.data[i].tipo === 1 ? 'TRANSFERENCIA' : response.data[i].tipo === 2 ? 'NOTA CREDITO' : response.data[i].tipo === 3 ? 'NOTA DEBITO' : 'CHEQUE'
            })
          }
          //setRecords(response.data);
          setRecords(mov);
        }
      }
      setActivate(false)
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })

  };

  const gestionarMovimiento = (op, id, index) => (e) => {
    if (op === 4) {
      setHabilitado(false);
      setOperacion(4);
      var mov = records;
      var mov = mov.filter(function (mov) {
        return mov.idmovimientosentransito === id;
      });
      setRegDet(mov[0]);
      setMostrar(true);
      /*    getExpendedor(id); */
    } else if (op === 1) {
      if (txtIdCuentaBancaria.current.value === '' || txtCuenta.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar una Cuenta Bancaaria.', icono: 'informacion' });
        return;
      }
      setOperacion(op);
      setHabilitado(true);
      setMostrar(true)
    } else if (op === 2) {
      setHabilitado(true);
      setOperacion(op);
      var mov = records;
      var mov = mov.filter(function (mov) {
        return mov.idmovimientosentransito === id;
      });
      if (mov[0].conciliado === 1){
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El movimiento no se puede modificar, ya está conciliado.', icono: 'informacion' });
        return;
      }
      setRegDet(mov[0]);
      setMostrar(true);
      /*   getExpendedor(id); */
    } else if (op === 3) {
      setOperacion(op);
      setHabilitado(false);
      var mov = records;
      var mov = mov.filter(function (mov) {
        return mov.idmovimientosentransito === id;
      });
      if (mov[0].conciliado === 1){
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El movimiento no se puede eliminar, ya está conciliado.', icono: 'informacion' });
        return;
      }
      setRegDet(mov[0]);
      setMostrar(true);
    }
  }

  const blanquear = () => {
    setActivate(false);
    setBody(null);
    setRecords([]);
    setOperacion(0);
    txtIdCuentaBancaria.current.value = '';
    txtCuenta.current.value = '';
  }

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })

  };


  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarCuentaBancaria(event.target.value);

      } else {
        txtCuenta.current.value = ''
      }
    }
  };

  const onChange = (e) => {

    if (e.target.name === 'idcuentabancaria') {
      txtCuenta.current.value = '';
      setRecords([]);
    }
  }

  const onCatalogoCuenta = (values) => {
    setCatalogoCuenta(false);
    txtIdCuentaBancaria.current.value = values.idcuentabancaria;
    seleccionarCuentaBancaria(values.idcuentabancaria);
  }


  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div className="row col-md-12 py-3" style={{ margin: 0 }}>
        <div className='row col-md-6 mx-auto' style={{ margin: 0 }}>
          <div className='col-md-12 py-1 mx-auto card shadow '>

            <div className='col-md-12 row mx-auto  rounded py-3'>
              <div className='col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between'>
                  <div className='col-md-6'>

                    <h3>
                      Gestion de Movimientos Transito
                    </h3>
                   

                  </div>
                  <div className='col-md-3 d-flex justify-content-end'>

                    <a href='/inicio' className='text-light '><i className="fas fa-times mx-2"></i><span className='fw-bold'>Salir</span></a>
                    
                    </div>
                </div>

              <div className='col-md-12 mx-auto' style={{fontSizeAdjust: '0.6'}}>
                <fieldset className=' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between'>
                  <legend className="float-none w-auto fw-bold" style={{ fontSize: '16px' }}>Cuenta Bancaria</legend>

                  <div className="input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-5 col-sm-4">
                    <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>
                    <input type="text" ref={txtIdCuentaBancaria} name='idcuentabancaria' className="form-control bg-light fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarCuenta} onBlur={validarCuenta} onChange={onChange} />
                    <button type="button" onClick={() => { setCatalogoCuenta(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>

                  </div>
                  <div className="input-group input-group-sm mb-2 col-xl-9 col-lg-12">
                    <input type="text" disabled ref={txtCuenta} name='cuentabancaria' className="form-control bg-light fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />

                  </div>


                </fieldset>
              </div>

              <div className='col-md-12 mx-auto mt-2'>
                <fieldset className=' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between'>
                  <legend className="float-none w-auto fw-bold" style={{ fontSize: '15px' }}>Movimientos</legend>

                  <div className="col-12 p-2">
                    <div className="row col-12 d-flex justify-content-between">
                      <input type="text" className=" col-3 form-control form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
                      <div className='col-3 d-flex justify-content-end'>
                        <button onClick={gestionarMovimiento(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer>
                      <TblHead />
                      <TableBody >
                        {
                          records && recordsAfterPagingAndSorting().map((item, index) => (
                            <TableRow key={index} style={{ padding: "0", fontSizeAdjust: '0.6' }}>
                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '240px' }}>{item.idmovimientosentransito}</TableCell>
                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '240px' }}>{item.tipomov}</TableCell>
                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '240px' }}>{item.referencia}</TableCell>
                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '270px' }}>{moment(item.fecha).format('DD/MM/YYYY')}</TableCell>
                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '270px' }}>{formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</TableCell>
                              <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '330px' }}>
                                <button onClick={gestionarMovimiento(4, item.idmovimientosentransito, index)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                                <button onClick={gestionarMovimiento(2, item.idmovimientosentransito, index)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                                <button onClick={gestionarMovimiento(3, item.idmovimientosentransito, index)} className="btn btn-sm mx-1 btn-danger rounded-circle"><i className="fa fa-trash"></i> </button>
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                    </TblContainer>
                    <TblPagination />
                  </div>


                </fieldset>
              </div>

            </div>

          </div>

        </div>
      </div >
      {/*  */}
      <IncluirMovimiento
        show={mostrar}
        operacion={operacion}
        idcuentabancaria={txtIdCuentaBancaria.current ? txtIdCuentaBancaria.current.value : '0'}
        idmovimiento={idMovimiento}
        habilitado={habilitado}
        registro={regDet}
        onHideCancela={() => { setMostrar(false) }}
        onHideRenderizar={() => { seleccionarMovimientos(txtIdCuentaBancaria.current.value) }}
      />
      <CatalogoCuentaBancaria
        show={catalogoCuenta}
        onHideCancelar={() => { setCatalogoCuenta(false) }}
        onHideAceptaCatalogo={onCatalogoCuenta}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
    </div>
  );
}
export default TablaMovimientosTransito;


// WEBPACK FOOTER //
// ./src/components/contabilidad/tablaMovimientoTransito.js